import React, { useEffect, useState } from "react";
import { X, ShieldCheck, ArrowRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { demoSeen, demoTrack } from "./demoMode";

export function PostDemoBanner({ D, current, guarantee, onBuy }) {
  const { user } = useAuth();
  const [closed, setClosed] = useState(sessionStorage.getItem("mc_post_demo_closed") === "1");
  const visible = user === false && demoSeen() && !closed;
  useEffect(() => { if (visible) demoTrack("reminder_view"); }, [visible]);
  if (!visible) return null;
  const close = () => { sessionStorage.setItem("mc_post_demo_closed", "1"); setClosed(true); demoTrack("reminder_close"); };
  return (
    <section className="relative z-10 -mt-6 px-4 pb-6 sm:-mt-10 sm:px-6" data-testid="v2-post-demo-banner">
      <div className="relative mx-auto max-w-5xl overflow-hidden rounded-[1.75rem] border border-xmas-gold/50 bg-xmas-navycard shadow-[0_0_60px_rgba(212,175,55,0.18)] float-up">
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-xmas-gold/15 via-transparent to-xmas-gold/10" />
        <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-xmas-gold to-transparent" />
        <button onClick={close} aria-label={D.remind.close} data-testid="v2-post-demo-close" className="absolute right-3 top-3 z-20 rounded-full p-1.5 text-xmas-slate transition hover:bg-white/10 hover:text-xmas-snow"><X className="h-4 w-4" /></button>
        <div className="relative grid items-center gap-5 p-6 sm:p-8 lg:grid-cols-[1.4fr_auto]">
          <div>
            <h3 className="font-display text-xl font-black uppercase text-xmas-gold sm:text-2xl" data-testid="v2-post-demo-title">{D.remind.t}</h3>
            <p className="mt-2 max-w-2xl text-sm text-xmas-champagne md:text-base">{D.remind.sub}</p>
          </div>
          <div className="flex flex-col items-start gap-3 lg:items-end">
            {current?.display && <p className="text-xs text-xmas-champagne">{D.remind.only} <b className="font-display text-2xl text-xmas-gold" data-testid="v2-post-demo-price">{current.display}</b></p>}
            <button onClick={() => { demoTrack("reminder_cta"); onBuy(); }} data-testid="v2-post-demo-cta" className="btn-gold inline-flex w-full items-center justify-center gap-2 rounded-full px-8 py-3.5 text-sm font-bold uppercase tracking-wider sm:w-auto">🎄 {D.remind.cta} <ArrowRight className="h-4 w-4" /></button>
            {guarantee && <p className="flex items-center gap-1.5 text-[11px] text-xmas-slate"><ShieldCheck className="h-3.5 w-3.5 text-xmas-gold" /> {guarantee}</p>}
          </div>
        </div>
      </div>
    </section>
  );
}
